import React from 'react'
import PropTypes from 'prop-types'
import history from 'browserHistory'

class ToasterRedirectButtonAction extends React.Component {
  static propTypes = {
    toasterMessage: PropTypes.shape({
      type: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      detail: PropTypes.string,
    }).isRequired,
    linkTarget: PropTypes.string.isRequired,
    // Wether to use react router to have an internal redirection without reloading the whole application or to just send the user to an external link
    isInternal: PropTypes.bool,
    children: PropTypes.node.isRequired,
  }

  handleClick = event => {
    const { isInternal, linkTarget } = this.props

    if (isInternal) {
      event.preventDefault()
      return history.push(linkTarget)
    }
  }

  render() {
    return (
      <a
        href={this.props.linkTarget}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.handleClick}
        className="inline-block primary primary-dark-on-hover font-size-large font-weight-semibold"
      >
        {this.props.children}
      </a>
    )
  }
}

export default ToasterRedirectButtonAction
